import { Box, Grid, Typography } from '@material-ui/core'
import React from 'react'

function CrfTabContent(props) {
    console.log("propsData", props.pageData)
    return <Box>
        <Grid container direction="row">
            <Box my={3} width="1">
                {
                    props.pageData.length > 0 && props.pageData.map((option) => {
                        return <Grid container direction="row" >
                            <Grid item xs={4} style={{ marginTop: "8px", textAlign: "justify", paddingRight: "20px" }}>
                                <Typography variant="h2" style={{ color: "#232323" }}>
                                    <Box mb={2} fontWeight="fontWeightBold">{option.field_value}</Box>
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Typography variant="h2" style={{ color: "#232323", textAlign: "justify" }}>
                                    <Box mb={2} >{option.answer}</Box>
                                </Typography>
                            </Grid>
                        </Grid>
                    })
                }
            </Box>
        </Grid>
    </Box>
}

export default CrfTabContent
